<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-rela.tive w-100">
            <div class="d-flex align-items-center w-100" style="height: 52% !important;">

                <img src="../../../assets/images/banners/image (37).png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="application" />


                <img src="../../../assets/images/banners/application-mobilebanner.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="mobileapplication" />

                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-8 col-md-6 col-sm-6 banner-section">
                            <div class="align-items-center banner-content-title  global_title global_banner_title  title_banner_content"
                                role="heading" aria-level="1">
                                <span>Application Services</span>
                            </div>
                            <div class="global_sub_title global_banner_subtitle mt-3" role="heading" aria-level="1">
                                <span>We build superior digital products that provide seamless user experiences across
                                    modern platforms.</span>
                            </div>
                            <div class="col pt-lg-3 pt-4 mt-lg-3">

                                <a href="contact" class="global_button   text-left col text-white white_button"
                                    aria-label="View Contact Page">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                            alt="arrow_img" /></div>
                                    EXPLORE
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<!--============ Banner End ============-->

<div class="laptop_bg_image mt-3">
    <div class="container-fluid ">
        <div class="row">
            <div class=" col-lg-6 col-12">
                <div class="mobile_service_images m-5">
                    <img src="../../../assets/images/application/application-bulidimage.png" class="img img-responsive"
                        alt="bulid future image" />
                </div>
            </div>
            <div class="col-lg-6 col-12">
                <div class="application_content_service global_section_header mt-5">
                    Build Future-ready applications
                </div>
                <div class="application_service-subcontent global_section_content mt-4">
                    <p>Our next-generation application development service empowers some of the world's most successful
                        businesses to streamline complex operations. We are dedicated to crafting top-tier software
                        products that boast full functionality, robustness, and scalability. </p>
                    <p>Take advantage of our full-stack expertise to unlock greater and swifter business value through
                        IT solutions driven by your business needs. Our commitment to technology excellence is evident
                        through automation, continuous delivery, and application modernization. We excel in assisting
                        you in creating consumer-facing or B2B apps across diverse digital platforms, including mobile,
                        web, desktop, smartwatch, VR, and AR. </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile End-to end Mobile application services -->
<div class="gradation-process-area section-space--ptb_100 mt-4">
    <div class="row">
        <div class="col-lg-1 col-sm-12"></div>
        <div class="col-lg-10 col-sm-12">
            <div class="gradation-title-wrapper section-space--mb_60">
                <div class="gradation-title-wrap  ">

                    <h1 class="heading  global_section_header">A world-class portfolio of EAS solutions </h1>
                    <p class="global_section_content">We combine the power of leading platforms—SAP, Oracle, Salesforce,
                        Workday, and others—with our intelligence, innovation, and industry capabilities to drive
                        large-scale, platform-enabled transformation. </p>
                </div>
                <div class="gradation-sub-heading">
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-1 col-sm-12"></div>
        <div class="col-lg-10 col-sm-12">
            <div class="ht-gradation style-01">
                <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left"
                    style="visibility: visible;animation-name: fadeInRight;">
                    <div class="line"></div>
                    <div class="circle-wrap">
                        <div class="mask">
                            <div class="wave-pulse wave-pulse-1"></div>
                            <div class="wave-pulse wave-pulse-2"></div>
                            <div class="wave-pulse wave-pulse-3"></div>
                        </div>
                        <div class="h4 circle"> <i role="presentation" class="fa fa-shopping-cart"></i></div>
                    </div>

                    <div class="content-wrap">
                        <a (click)="scrollToSection('androidappdev')" role="button">
                            <div class="sixthheading heading">E-commerce Development</div>
                        </a>
                        <div class="text global_section_content">Create custom storefronts and digital solutions for
                            various business models and platforms. </div>
                        <a class="gradation-btn gradation-btn1" (click)="scrollToSection('androidappdev')"
                            role="button">
                            <span class="service-button-text" data-text="Look more">
                                Learn more </span>
                            <span><i role="presentation" class="button-icon fas fa-long-arrow-right"></i></span>
                        </a>
                    </div>
                </div>
                <!-- Single item gradation End -->
                <!-- Single item gradation Start -->
                <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left"
                    style="visibility: visible;animation-name: fadeInRight;">
                    <div class="line"></div>
                    <div class="circle-wrap">
                        <div class="mask">
                            <div class="wave-pulse wave-pulse-1"></div>
                            <div class="wave-pulse wave-pulse-2"></div>
                            <div class="wave-pulse wave-pulse-3"></div>
                        </div>
                        <div class="h4 circle"><i role="presentation" class=" fa fa-desktop"></i></div>
                    </div>
                    <div class="content-wrap">
                        <a (click)="scrollToSection('iosappdev')" role="button">
                            <div class="sixthheading heading">Custom Development </div>
                        </a>
                        <div class="text global_section_content"> Build and modernize your applications, tailored to
                            your business needs.
                        </div>
                        <a class="gradation-btn gradation-btn2" (click)="scrollToSection('iosappdev')" role="button">
                            <span class="service-button-text" data-text="Look more">
                                Learn more </span>
                            <span><i role="presentation" class="button-icon fas fa-long-arrow-right"></i></span>
                        </a>
                    </div>
                </div>
                <!-- Single item gradation End -->

                <!-- Single item gradation Start -->
                <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left"
                    style="visibility: visible;animation-name: fadeInRight;">
                    <div class="line"></div>
                    <div class="circle-wrap">
                        <div class="mask">
                            <div class="wave-pulse wave-pulse-1"></div>
                            <div class="wave-pulse wave-pulse-2"></div>
                            <div class="wave-pulse wave-pulse-3"></div>
                        </div>
                        <div class="h4 circle"> <i role="presentation" class="fa fa-code"></i></div>
                    </div>
                    <div class="content-wrap">
                        <a (click)="scrollToSection('arappdev')" role="button">
                            <div class="sixthheading heading">Open- Source </div>
                        </a>
                        <div class="text global_section_content">Ensure high-performance business operations with our
                            versatile open-source solutions. </div>
                        <a class="gradation-btn gradation-btn3" (click)="scrollToSection('arappdev')" role="button">
                            <span class="service-button-text" data-text="Look more">
                                Learn more </span>
                            <span><i role="presentation" class="button-icon fas fa-long-arrow-right"></i></span>
                        </a>
                    </div>
                </div>
                <!-- Single item gradation End -->

                <!-- Single item gradation Start -->
                <div class="item item-1 animate wow fadeInRight" data-aos="fade-left"
                    style="visibility: visible;animation-name: fadeInRight;">
                    <div class="line"></div>
                    <div class="circle-wrap">
                        <div class="mask">
                            <div class="wave-pulse wave-pulse-1"></div>
                            <div class="wave-pulse wave-pulse-2"></div>
                            <div class="wave-pulse wave-pulse-3"></div>
                        </div>
                        <div class="circle"><i role="presentation" class="fa fa-edit"></i></div>
                    </div>
                    <div class="content-wrap">
                        <a (click)="scrollToSection('crossappdev')" role="button">
                            <div class="sixthheading heading">UI/UX </div>
                        </a>
                        <div class="text global_section_content">Create user-centered, appealing, and robust experiences
                            with consistent cross-platform compatibility. </div>
                        <a class="gradation-btn gradation-btn4" (click)="scrollToSection('crossappdev')" role="button">
                            <span class="service-button-text" data-text="Look more">
                                Learn more </span>
                            <span><i role="presentation" class="button-icon fas fa-long-arrow-right"></i></span>
                        </a>
                    </div>
                </div>
                <!-- Single item gradation End -->
            </div>
        </div>
    </div>

</div>

<!-- Android app development starts -->
<div class="Custom-Web android-development mt-5">
    <div class="container-fluid " id="androidappdev">
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <div class="mobile_android_content global_section_header mb-md-5">
                    E-commerce Website
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class="offset-sm-1 col-sm-11">
                        <div class="mobile_androidsub-content global_section_content">
                            <p class=" application_subcontent">We are adept at combining brand imagination with our
                                reliable tech stack to create the store of your dreams. Our eCommerce web developers
                                review your requirements, identify industry barriers, and define scopes to develop an
                                eCommerce website. We serve platforms such as Shopify, Magento, WooCommerce, WordPress,
                                and Squarespace.
                            </p>
                        </div>
                        <ul class="global_section_content application_list ">
                            <li>Shopify</li>
                            <li>Magento</li>
                            <li>WooCommerce & WordPress</li>
                            <li>Squarespace</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class="col-sm-11">
                        <div class="mobile_android-image">
                            <img class="img img-responsive w-100"
                                src="../../../assets/images/application/ecommerce.webp" alt="ecommerce" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Android app development ends -->

<!--  Custom Web application development starts -->
<hr>
<div class="Custom-Web">
    <div class="container-fluid mt-3" id="iosappdev">
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <div class="mobile_android_content global_section_header mb-md-5">
                    Custom Web application development
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class="offset-sm-1 col-sm-11">
                        <div class="mobile_ios_images mobile_androidsub-content global_section_content">
                            <img class="img img-responsive w-100" src="../../../assets/images/application/custombg.jpg"
                                alt="custom web development" />
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class=" col-sm-11">
                        <div
                            class="mobile_ios-subcontent global_section_content mobile_androidsub-content global_section_content">
                            <p class=" application_subcontent">
                                Our custom web development solutions prioritize usability, scalability, and
                                compatibility across various browsers and platforms. Each module is thoughtfully
                                designed to seamlessly integrate with a framework that ensures robust security and
                                thorough audits, guaranteeing that our web solutions are as secure as desktop
                                counterparts.
                            </p>
                            <p class="application_subcontent">We modernize your applications with foolproof
                                methodologies and tools to give your legacy app the benefits of cloud, speed,
                                performance, scale, new feature development, etc. </p>
                        </div>
                        <ul class=" global_section_content application_list  application_list2 ">
                            <li>Cross-platform apps</li>
                            <li>E-commerce solutions</li>
                            <li>Web portal development</li>
                            <li>Custom CMS web development</li>
                            <li>Technology consulting</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Custom Web application development ends -->

<!--Open source developmentstarts -->
<hr>
<div class="Custom-Web Opensource" id="arappdev">
    <div class="container-fluid mt-2">
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <div class="mobile_android_content  mobile_android_content1 global_section_header mb-md-5">
                    Open source development
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class="offset-sm-1 col-sm-11">
                        <div
                            class="mobile_websub-content global_section_content mobile_androidsub-content global_section_content">
                            <p class=" application_subcontent">Our experts excel in crafting feature-rich applications
                                that offer a competitive edge while significantly reducing engineering efforts and
                                costs. Leveraging robust frameworks and methodologies, we have the capability to develop
                                a wide spectrum of applications, spanning web, mobile, service-oriented, Windows, and
                                rich internet applications. </p>
                            <p class="application_subcontent">Our comprehensive services cover the entire spectrum of
                                application development, from initial strategy and implementation to architectural
                                consulting, application development, and ongoing support and maintenance.
                            </p>
                        </div>
                        <ul class="global_section_content application_list application_list3 ">
                            <li>Strategy / Implementation</li>
                            <li>Architectural Consulting</li>
                            <li>Application Development</li>
                            <li>Support & Maintenance</li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class="col-sm-11">
                        <div class="mobile_web-image">

                            <img class="img img-responsive w-100"
                                src="../../../assets/images/application/open-bgimage.jpg" alt="opensource" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Open source development ends -->

<!------UI/UX Design starts -->
<hr>
<div class="Custom-Web UI/UX ">
    <div class="container-fluid" id="crossappdev">
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <div class="mobile_android_content global_section_header mb-md-5">
                    UI/UX Design
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class="offset-sm-1 col-sm-11">
                        <div class="mobile_cross_image">
                            <img class="img img-responsive w-100"
                                src="../../../assets/images/application/ui-bgimage.png" alt="UI UX Design" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class=" col-sm-11">
                        <div
                            class="mobile_websub-content global_section_content mobile_androidsub-content global_section_content">
                            <p class="">We recognize the significance of good design in achieving digital success. Our
                                approach revolves around creating user-centered, visually appealing, and robust
                                experiences that guide users seamlessly. We specialize in producing responsive and
                                adaptive designs that ensure consistent cross-platform compatibility. Our process
                                involves leveraging a variety of cutting-edge technologies and innovative ideas to bring
                                your brand's vision to life using modern tools and thinking.
                            </p>
                        </div>
                        <ul class="global_section_content application_list application_list4">
                            <li> Interactive Design</li>
                            <li>Experience Design</li>
                            <li>Testing and Audit</li>
                            <li>Security Management</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--------UI/UX Design Ends -->
    <!-- Insight Blogs Section Starts--->
    <div class="service-projects-wrapper bg-gray section-space--ptb_60 mt-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-wrap text-center section-space--mb_60">
                        <div class="sixthheading global_section_header section-sub-title mb-20" role="heading"
                            aria-level="1">Related Reading</div>
                    </div>
                </div>
            </div>
            <div class="latest-news-wrap">
                <div class="row">
                    <div class="col-lg-1 col-sm-12"></div>
                    <div class="col-lg-5">
                        <div class="single-blog-lg-item wow move-up">
                            <a (click)="scrollToSection('main-wrapper')" role="button">
                                <div class="post-blog-thumbnail">
                                    <img class="img img-responsive"
                                        src="../../../assets/images/application/blogs-1.webp" alt="Personalisation" />
                                </div>
                            </a>
                            <!-- Post Feature End -->

                            <!-- Post info Start -->
                            <div class="post-info lg-blog-post-info mt-20">
                                <div class="fourthheading global_sub_title post-title">
                                    <a href="/personalize-and-machine-learning"
                                        aria-label="Read Personalize ML">Personalisation and Machine Learning in
                                        Marketing</a>
                                </div>
                                <div class="global_section_content post-excerpt mt-15">
                                    <p>
                                        Technology is getting personalised. So surprisingly personalised that you no
                                        longer
                                        have to remember your shopping you’ve left midway-
                                        the internet reminds you anyway.
                                        Big data and Machine learning have dug deep into human interests that we don’t
                                        have
                                        to search for anything to get anywhere- it comes to you!</p>
                                </div>
                                <div class="btn-text mt-15">
                                    <a href="personalize-and-machine-learning" aria-label="Read Personalize ML">Read
                                        more
                                        <i role="presentation"
                                            class="ml-1 button-icon fa-solid fa-arrow-right-long"></i></a>
                                </div>
                            </div>
                            <!-- Post info End -->
                        </div>
                    </div>
                    <div class="col-lg-5 blog-list-service">
                        <div class="single-blog-lg-list wow move-up">
                            <!-- Post Feature Start -->
                            <a href="/migrate-cloud" aria-label="blogs-2" aria-label="Read migrate cloud Insights">
                                <div class="post-blog-thumbnail">
                                    <img class="img img-responsive"
                                        src="../../../assets/images/application/blogs-2.webp" alt="Digital Marketing" />

                                </div>
                            </a>
                            <!-- Post Feature End -->

                            <!-- Post info Start -->
                            <div class="post-info lg-blog-post-info">

                                <div class="fifthheading global_sub_title  post-title">
                                    <a href="/migrate-cloud" aria-label="Read migrate cloud Insights" style="display: inline-block; padding: 6px;">The new wave of
                                        Digital Marketing in the
                                        Post-Pandemic world</a>
                                </div>
                            </div>
                            <!-- Post info End -->
                        </div>
                        <div class="single-blog-lg-list wow move-up">
                            <!-- Post Feature Start -->
                            <a href="/postpandamic" aria-label="cloudmigrationblog"
                                aria-label="Read Postpandamic Insights">
                                <div class="post-blog-thumbnail">
                                    <img class="img img-responsive"
                                        src="../../../assets/images/blogs/cloudmigrationblog.webp"
                                        alt="Cloud Migration" />


                                </div>
                            </a>
                            <!-- Post Feature End -->

                            <!-- Post info Start -->
                            <div class="post-info lg-blog-post-info">

                                <div class="fifthheading global_sub_title  post-title">
                                    <a href="/postpandamic" aria-label="Read Postpandamic Insights" style="padding: 10px ; display: inline-block;">Why is Cloud
                                        migration critical in the COVID-19 scenario</a>
                                </div>
                            </div>
                            <!-- Post info End -->
                        </div>
                        <div class="single-blog-lg-list wow move-up">
                            <!-- Post Feature Start -->
                            <a href="/h1b-visa" aria-label="Read H1-B Visa Insights">
                                <div class="post-blog-thumbnail">
                                    <img class="img img-responsive"
                                        src="../../../assets/images/application/visa-application.webp"
                                        alt="Visa_Application" />

                                </div>
                            </a>
                            <!-- Post Feature End -->

                            <!-- Post info Start -->
                            <div class="post-info lg-blog-post-info">

                                <div class="fifthheading global_sub_title  post-title">
                                    <a href="/h1b-visa" aria-label="Read H1-B Visa Insights" style="display: inline-block; padding: 10px;">What is an H1B Visa?</a>
                                </div>
                            </div>
                            <!-- Post info End -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>